import styled from 'styled-components';

const MainWrapper = styled.div`
	height: 100%;
	font-size: 14px;
`;

export default MainWrapper;
